import React from 'react'

const Aple = ({ size = 24, color = '#3076D0', ...props }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill="none"
		{...props}
	>
		<path
			d="M16.9974 21.1575C15.8344 22.2656 14.5645 22.0907 13.3422 21.5657C12.0486 21.0291 10.8618 21.0058 9.49699 21.5657C7.78802 22.289 6.88607 22.079 5.86544 21.1575C0.073947 15.2899 0.92843 6.35432 7.5032 6.0277C9.10535 6.10935 10.2209 6.89092 11.1585 6.96091C12.5589 6.68095 13.8999 5.87605 15.3953 5.98104C17.1873 6.12102 18.5403 6.82093 19.4303 8.08077C15.7276 10.2622 16.6058 15.0566 20 16.3981C19.3235 18.1478 18.4453 19.886 16.9856 21.1691L16.9974 21.1575ZM11.0398 5.95771C10.8618 3.35637 13.0099 1.20997 15.4784 1C15.8225 4.00962 12.7013 6.24934 11.0398 5.95771Z"
			fill={color}
		/>
	</svg>
)

export default Aple;
